import Api from '@/vuex/api'
import { app } from '@/main'
import {
  ADD_CAR_NOTE,
  ADD_PETROL_CARD,
  CANCEL_PETROL_CARD,
  CAPTURE_CARD,
  EDIT_CAR,
  GPS_LOCATION,
  IGNITION_ON,
  IGNITION_OFF,
  IMMOBILIZE_VEHICLE,
  INSTANT_RESERVATION,
  LOAD_CAR,
  LOAD_CAR_AVAILABILITY,
  LOAD_CAR_DAMAGES,
  LOAD_CAR_DAMAGES_TOTAL,
  LOAD_CAR_EXTRAS,
  LOAD_CAR_FEATURES,
  LOAD_CAR_GRAPHS,
  LOAD_CAR_LIST,
  LOAD_CAR_MESSAGES,
  LOAD_CAR_MESSAGES_TOTAL,
  LOAD_CAR_MESSAGES_TYPE,
  LOAD_CAR_NOTES,
  LOAD_CAR_NOTES_TOTAL,
  LOAD_CAR_RATES,
  LOAD_CAR_RESERVATIONS,
  LOAD_CAR_RESERVATIONS_COLUMNS,
  LOAD_CAR_RESERVATIONS_TOTAL,
  LOAD_CAR_UPCOMING_RESERVATIONS,
  LOAD_PETROL_CARDS,
  LOCK_CAR,
  MOVE_CAR,
  NEW_MAINTENANCE,
  NEW_RESERVATION,
  OPEN_MODAL,
  REPORT_DAMAGE,
  RESERVE_CAR,
  UNLOCK_CAR
} from '@/vuex/types'

const api = new Api()
const state = {
  car: {
    uuid: '',
    availability: [],
    name: '',
    convadisId: 0,
    color: '',
    rego: '',
    FleetContract: {},
    CarType: {
      AmazonImage: {},
      CarClass: {
        name: ''
      }
    },
    CarHardware: {
      provider: ''
    },
    ServicePerson: {},
    Lot: {},
    LotRelocations: [],
    AccountNotes: [],
    CarDamages: [],
    CarDamagesTotal: 0,
    CarMessages: [],
    CarMessagesTotal: 0,
    CarMessagesType: '',
    PetrolCards: [],
    Reservations: [],
    ReservationColumns: [],
    ReservationsTotal: 0,
    Notes: [],
    NotesTotal: 0,
    rates: [],
    Valets: []
  },
  availableCars: [],
  extras: [],
  graphData: {},
  ccomCommands: [
    // { label: 'Instant Reservation', command: INSTANT_RESERVATION, icon: 'fa-sign-in-alt' },
    { label: 'Capture Next Card', command: CAPTURE_CARD, icon: 'fa fa-id-card' },
    { label: 'Unlock Car', command: UNLOCK_CAR, icon: 'fa fa-unlock' },
    { label: 'Lock Car', command: LOCK_CAR, icon: 'fa fa-lock' },
    { label: 'Ignition On', command: IGNITION_ON, icon: 'fa fa-key' },
    { label: 'Ignition Off', command: IGNITION_OFF, icon: 'fa fa-power-off' },
    { label: 'Immobilize Vehicle', command: IMMOBILIZE_VEHICLE, icon: 'fa fa-ban' },
    { label: 'GPS Location', command: GPS_LOCATION, icon: 'fa fa-crosshairs' }
  ],
  carActions: [
    { label: 'New Reservation', command: NEW_RESERVATION, icon: 'fa fa-calendar-alt' },
    { label: 'Schedule Maintenance', command: NEW_MAINTENANCE, icon: 'fa fa-wrench' },
    { label: 'Edit Details', command: EDIT_CAR, icon: 'fa fa-edit' },
    { label: 'Move Vehicle', command: MOVE_CAR, icon: 'fa fa-random' },
    { label: 'Report Damage', command: REPORT_DAMAGE, icon: 'fa fa-exclamation-triangle' },
    { label: 'Add Note', command: ADD_CAR_NOTE, icon: 'fa fa-sticky-note' }
  ],
  features: []
}

const getters = {
  loadedCar (state) {
    return state.car
  },
  carAvailability (state) {
    return state.car.availability
  },
  carList (state) {
    return state.availableCars
  },
  carRates (state) {
    return state.car.rates
  },
  carExtras (state) {
    return state.extras
  },
  carMessages (state) {
    return state.car.CarMessages
  },
  carMessagesTotal (state) {
    return state.car.CarMessagesTotal
  },
  carMessagesType (state) {
    return state.car.CarMessagesType
  },
  carCommands (state) {
    return state.ccomCommands
  },
  carActions: ({ carActions }) => (car) => {
    let excludeActions = []
    if (car.carSold || car.carRetired) {
      excludeActions = excludeActions.concat([
        NEW_RESERVATION, NEW_MAINTENANCE
      ])
    }
    return carActions.filter(el => !excludeActions.includes(el.command))
  },
  carGraphs (state) {
    return state.graphData
  },
  carReservations (state) {
    return state.car.Reservations
  },
  carReservationsColumns (state) {
    return state.car.ReservationColumns
  },
  carReservationsTotal (state) {
    return state.car.ReservationsTotal
  },
  carNotes (state) {
    return state.car.Notes
  },
  carNotesTotal (state) {
    return state.car.NotesTotal
  },
  carDamages (state) {
    return state.car.CarDamages
  },
  carDamagesTotal (state) {
    return state.car.CarDamagesTotal
  },
  carFeatures (state) {
    return state.features
  }
}

const mutations = {
  [LOAD_CAR] (state, car) {
    state.car = { ...state.car, ...car }
  },
  [LOAD_CAR_LIST] (state, cars) {
    state.availableCars = cars
  },
  [LOAD_CAR_AVAILABILITY] (state, availability) {
    state.car = { ...state.car, availability }
  },
  [LOAD_CAR_RATES] (state, rates) {
    state.car = { ...state.car, rates }
  },
  [LOAD_CAR_FEATURES] (state, features) {
    state.features = features
  },
  [LOAD_CAR_EXTRAS] (state, extras) {
    state.extras = extras
  },
  [LOAD_CAR_MESSAGES] (state, messages) {
    state.car = { ...state.car, CarMessages: messages }
  },
  [LOAD_CAR_MESSAGES_TOTAL] (state, count) {
    state.car = { ...state.car, CarMessagesTotal: count }
  },
  [LOAD_CAR_MESSAGES_TYPE] (state, type) {
    state.car = { ...state.car, CarMessagesType: type }
  },
  [LOAD_CAR_RESERVATIONS] (state, reservations) {
    state.car = { ...state.car, Reservations: reservations }
  },
  [LOAD_CAR_RESERVATIONS_TOTAL] (state, count) {
    state.car = { ...state.car, ReservationsTotal: count }
  },
  [LOAD_CAR_RESERVATIONS_COLUMNS] (state, columns) {
    state.car = { ...state.car, ReservationColumns: columns }
  },
  [LOAD_CAR_NOTES] (state, notes) {
    state.car = { ...state.car, Notes: notes }
  },
  [LOAD_CAR_NOTES_TOTAL] (state, count) {
    state.car = { ...state.car, NotesTotal: count }
  },
  [LOAD_CAR_DAMAGES] (state, damages) {
    state.car = { ...state.car, CarDamages: damages }
  },
  [LOAD_CAR_DAMAGES_TOTAL] (state, count) {
    state.car = { ...state.car, CarDamagesTotal: count }
  },
  [LOAD_CAR_GRAPHS] (state, data) {
    state.graphData = { ...state.graphData, ...data }
  },
  [LOAD_PETROL_CARDS] (state, data) {
    state.car = { ...state.car, PetrolCards: data }
  }
}

const actions = {
  async [LOAD_CAR] (context, { carUuid, startTime, endTime }) {
    let car = await api.getCar(carUuid, startTime, endTime)
    context.commit(LOAD_CAR, car)
  },
  async [LOAD_CAR_LIST] (context, driverUuid) {
    let cars = await api.getCarList(driverUuid)
    context.commit(LOAD_CAR_LIST, cars)
  },
  async [LOAD_CAR_AVAILABILITY] (context, payload) {
    let availability = await api.getCarAvailability(payload.carUuid, payload.startTime, payload.proposedStartTime, payload.proposedEndTime)
    context.commit(LOAD_CAR_AVAILABILITY, availability)
  },
  async [INSTANT_RESERVATION] (context, car) {
    if (!car) car = context.state.car
    await api.instantReservation(car.uuid)
    context.commit(OPEN_MODAL, {
      title: 'Success!',
      html: `
      <p>Instant reservation command sent.</p>
      <p>Car will create and automatically log in to a new reservation.</p>
      <p>Check Car Messages Log to see result.</p>
      `
    })
  },
  async [IGNITION_ON] (context, car) {
    if (!car) car = context.state.car
    await api.ignitionOn(car.uuid)
    context.commit(OPEN_MODAL, {
      title: 'Success!',
      html: `
      <p>Ignition on command sent.</p>
      <p>Car will turn off automatically in 45 minutes.</p>
      <p>Check Car Messages Log to see result.</p>
      `
    })
  },
  async [IGNITION_OFF] (context, car) {
    if (!car) car = context.state.car
    await api.ignitionOff(car.uuid)
    context.commit(OPEN_MODAL, {
      title: 'Success!',
      html: `
      <p>Ignition off command sent.</p>
      <p>Car will turn off automatically.</p>
      <p>Check Car Messages Log to see result.</p>
      `
    })
  },
  async [CAPTURE_CARD] (context, car) {
    if (!car) car = context.state.car
    await api.captureCard(car.uuid)
    context.commit(OPEN_MODAL, {
      title: 'Success!',
      html: `
      <p>Capture Next Card command sent.</p>
      <p>Next card swiped on vehicle will be captured in a message.</p>
      <p>Check Car Messages Log to see result.</p>
      `
    })
  },
  async [UNLOCK_CAR] (context, car) {
    if (!car) car = context.state.car
    await api.unlockCar(car.uuid)
    context.commit(OPEN_MODAL, {
      title: 'Success!',
      html: `
      <p>Unlock car command sent.</p>
      <p>Car will unlock doors for customer automatically.</p>
      <p>Check Car Messages Log to see result.</p>
      `
    })
  },
  async [LOCK_CAR] (context, car) {
    if (!car) car = context.state.car
    await api.lockCar(car.uuid)
    context.commit(OPEN_MODAL, {
      title: 'Success!',
      html: `
      <p>Lock car command sent.</p>
      <p>Car will lock doors for customer automatically.</p>
      <p>Check Car Messages Log to see result.</p>
      `
    })
  },
  async [IMMOBILIZE_VEHICLE] (context, car) {
    if (!car) car = context.state.car
    await api.immobilizeVehicle(car.uuid)
    context.commit(OPEN_MODAL, {
      title: 'Success!',
      html: `
      <p>Immobilize vehicle command sent.</p>
      <p>Car will immobilize on next ignition off.</p>
      <p>Check Car Messages Log to see result.</p>
      `
    })
  },
  async [GPS_LOCATION] (context, car) {
    if (!car) car = context.state.car
    await api.gpsLocation(car.uuid)
    context.commit(OPEN_MODAL, {
      title: 'Success!',
      html: `
      <p>Request GPS command sent.</p>
      <p>Car will return GPS coordinates in next message.</p>
      <p>Check Car Messages Log to see result.</p>
      `
    })
  },
  async [REPORT_DAMAGE] (context, car) {
    if (!car) car = context.state.car
    let damageModal = {
      permalink: 'reportDamage',
      options: {
        title: 'Report Damage',
        actionLabel: 'Report Damage'
      },
      params: { carUuid: car.uuid }
    }
    context.commit(OPEN_MODAL, damageModal)
  },
  async [ADD_CAR_NOTE] (context, car) {
    if (!car) car = context.state.car
    let noteModal = {
      permalink: 'newNote',
      options: {
        title: 'Add Note',
        actionLabel: 'Add Note'
      },
      params: { carUuid: car.uuid }
    }
    context.dispatch(OPEN_MODAL, noteModal)
  },
  async [ADD_PETROL_CARD] (context, car) {
    if (!car) car = context.state.car
    let addPetrolCardModal = {
      permalink: 'addPetrolCard',
      options: {
        title: 'Add Petrol Card',
        actionLabel: 'Save'
      },
      params: { CarUuid: car.uuid }
    }
    context.dispatch(OPEN_MODAL, addPetrolCardModal)
  },
  async [CANCEL_PETROL_CARD] (context, card) {
    let addPetrolCardModal = {
      permalink: 'cancelPetrolCard',
      options: {
        title: 'Cancel Petrol Card',
        actionLabel: 'Save'
      },
      params: { PetrolCardUuid: card.uuid }
    }
    context.dispatch(OPEN_MODAL, addPetrolCardModal)
  },
  async [RESERVE_CAR] (context, { car, driver, start, end, maintenance }) {
    let reserveModal = {
      permalink: 'newReservation',
      options: {
        title: 'Confirm Reservation',
        actionLabel: 'Confirm'
      },
      params: {
        carUuid: car.uuid,
        driverUuid: driver,
        start,
        end,
        maintenance
      }
    }
    context.commit(OPEN_MODAL, reserveModal)
    context.commit(LOAD_CAR, car)
    context.dispatch(LOAD_CAR_RATES)
    context.dispatch(LOAD_CAR_EXTRAS, car.uuid)
  },
  async [NEW_RESERVATION] (context, car) {
    app.$router.push('/fleet/reservations/new/?c=' + car.uuid)
  },
  async [NEW_MAINTENANCE] (context, car) {
    app.$router.push('/fleet/maintenance/new/?c=' + car.uuid)
  },
  async [EDIT_CAR] (context, car) {
    app.$router.push('/fleet/vehicles/edit/' + car.uuid)
  },
  async [MOVE_CAR] (context, car) {
    app.$router.push('/fleet/vehicles/move/' + car.uuid)
  },
  async [LOAD_CAR_RATES] (context) {
    let rates = await api.getRates()
    context.commit(LOAD_CAR_RATES, rates)
  },
  async [LOAD_CAR_FEATURES] (context, accountUuid = false) {
    let features = await api.getCarFeatures(accountUuid)
    context.commit(LOAD_CAR_FEATURES, features)
  },
  async [LOAD_CAR_EXTRAS] (context, carUuid) {
    let extras = await api.getExtras(carUuid)
    context.commit(LOAD_CAR_EXTRAS, extras)
  },
  async [LOAD_CAR_GRAPHS] (context, formData) {
    let data = await api.getCarData(formData)
    context.commit(LOAD_CAR_GRAPHS, data)
  },
  async [LOAD_CAR_UPCOMING_RESERVATIONS] (context, carUuid) {
    let reservations = await api.getUpcomingReservations(carUuid)
    context.commit(LOAD_CAR_RESERVATIONS, reservations)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/car.js